import { MLB_TEAMS } from 'lib_ts/enums/mlb.enums';
import { IHitter } from 'lib_ts/interfaces/i-hitter';
import { useMemo } from 'react';

export const HitterLibraryTeamLogo = (props: {
  // e.g. 48px
  size: string;
  hitter: IHitter;
}) => {
  const url = useMemo(() => {
    if (!props.hitter._mx_mlb_team_details) {
      // no details => no logo
      return undefined;
    }

    const { code, teamPk } = props.hitter._mx_mlb_team_details;

    if (!teamPk) {
      // no teamPk => no logo
      return undefined;
    }

    // Check if this is a rookie-level team (FCL, ACL, DSL)
    if (code?.match(/^(FCL|ACL|DSL)-/)) {
      // Extract the parent team abbreviation from codes like "FCL-BAL", "DSL-NYY", "ACL-LAA"
      const parts = code.split('-');
      const parentCode = parts[1];

      // Find the parent MLB team
      const parentTeam = MLB_TEAMS.find((t) => t.code === parentCode);

      if (parentTeam) {
        return `https://www.mlbstatic.com/team-logos/${parentTeam.teamPk}.svg`;
      }
    }

    return `https://www.mlbstatic.com/team-logos/${teamPk}.svg`;
  }, [props.hitter._mx_mlb_team_details]);

  if (!url) {
    return null;
  }

  return (
    <img
      style={{ objectFit: 'contain' }}
      loading="lazy"
      height={props.size}
      width={props.size}
      alt={props.hitter._mx_mlb_team_details?.name ?? 'Team'}
      src={url}
    />
  );
};
